import { FC } from "react";

import { ButtonGroup, Column, Text } from "@hightouch/htui";
import { LinkButton, useLocation } from "src/router";

import { AuthLayout } from "src/components/auth/auth-layout";
import { AuthCard } from "src/components/auth/auth-card";
import { useUser } from "src/contexts/user-context";

export const Unauthorized: FC = () => {
  const { user, workspace } = useUser();
  const location = useLocation();
  const state = location?.state as { error: string } | undefined;

  return (
    <AuthLayout metaTitle="Access restricted">
      <AuthCard heading="Access restricted" gap={8}>
        <Text>
          {state?.error || `You aren’t authorized to access this resource`}
        </Text>

        <Column gap={3} width="100%" align="center">
          {workspace ? (
            <LinkButton href="/">Back to workspace</LinkButton>
          ) : user ? (
            <LinkButton href="/workspaces">Back to workspaces</LinkButton>
          ) : (
            <ButtonGroup>
              <LinkButton href="/login">Login</LinkButton>
            </ButtonGroup>
          )}
        </Column>
      </AuthCard>
    </AuthLayout>
  );
};
